const swipeLocation = { // xtra display 
  p: 'p',
  out: 'out',
  long: 'long',
  wide: 'wide',
  net: 'net'
}


export const settings = {
  resultColors: {

    action: 'green',
    position: 'purple',
    result: 'blue',
    zone: 'brown',
    team: 'green',
    ace: 'black',
    block: 'orange',
    blocked: 'black',
    dig: 'brown',
    dug: 'brown',
    error: 'red',
    inPlay: 'grey',
    kill: 'green',
    overpass: 'grey',
    p: 'grey',
    point: 'green',
    stuffBlock: 'black',
    tip: 'pink',

    xtra: 'red',
    net: 'red',
    out: 'red',
    long: 'red',
    wide: 'red',
  },
  resultIcons: {
    ace: 'checkmark box',
    block: 'checkmark box',
    blocked: 'checkmark box',
    dig: 'checkmark box',
    error: 'close',
    inPlay: 'checkmark box',
    kill: 'checkmark box',
    long: 'close',
    net: 'close',
    out: 'close',
    overpass: 'checkmark box',
    p: 'question circle',
    point: 'checkmark box',
    stuffBlock: 'checkmark box',
    tip: 'checkmark box',
    wide: 'close',
    zone: 'location arrow',
    result: 'bar graph',
    xtra: 'info circle'
  },
  rt: { // result types
    nothing: 'nothing',
    p: 'p',

    ace: 'ace',
    block: 'block',
    blocked: 'blocked',
    dig: 'dig',
    error: 'error',
    inPlay: 'inPlay',
    kill: 'kill',
    overpass: 'overpass',
    point: 'point',
    stuffBlock: 'stuffBlock',
    tip: 'tip',
    zone: 'zone',
  }
}

const swipe = {
  requestItems: {
    serve: { // A ction, Z one, X xtra
      // action: null,
      zone: null,
      // get the result after...
      // swipeResult: null,
      xtra: null
    },
    pass: { // A ction, Z one, X xtra
      // action: null,
      zone: null,
      // get the result after...
      // result: null,
      xtra: null
    },
    attack: { // A ction, Z one, X xtra
      action: null,
      zone: null,
      xtra: null
    },
    oppAttack: { // A ction, Z one, X xtra
      action: null,
      zone: null,
      // result: null,
      xtra: null
    },
  },
  resultItems: {
    serve: {
      crossCourt: settings.rt.inPlay,
      cb: settings.rt.p,
      error: settings.rt.error,
      holders: {
        inPlay: settings.rt.ace,
      },
    },
    pass: {
      crossCourt: settings.rt.inPlay,
      cb: settings.rt.p,
      error: settings.rt.error,
    },
    attack: {
      crossCourt: settings.rt.inPlay,
      cb: settings.rt.block,
      error: settings.rt.error,
      holders: {
        inPlay: settings.rt.kill,
        block: settings.rt.blocked
      },
      slowers: {
        inPlay: settings.rt.tip,
      },
    },
    oppAttack: {
      crossCourt: settings.rt.inPlay,
      cb: settings.rt.block,
      error: settings.rt.error,
      holders: {
        inPlay: settings.rt.kill,
        block: settings.rt.blocked
      },
      slowers: {
        inPlay: settings.rt.tip,
      },
    },
  },
  xtraItems: {
    up: {
      above: swipeLocation.out,
      below: swipeLocation.net,
      lol: swipeLocation.wide,
      ror: swipeLocation.wide
    },
    down: {
      above: swipeLocation.net,
      below: swipeLocation.out,
      lol: swipeLocation.wide,
      ror: swipeLocation.wide
    }
  }
}


export const swipeData = {
  serve: { // swipe up
    requestItems: swipe.requestItems.serve,
    resultItems: swipe.resultItems.serve,
    xtraResultItems: swipe.xtraItems.up,
    validate: function () {
      return validate(this.requestItems)
    }
  },
  pass: {  // swipe down
    requestItems: swipe.requestItems.pass,
    resultItems: swipe.resultItems.pass,
    xtraResultItems: swipe.xtraItems.down,
    validate: function () {
      return validate(this.requestItems)
    }
  },
  attack: { // swipe up
    requestItems: swipe.requestItems.attack,
    resultItems: swipe.resultItems.attack,
    xtraResultItems: swipe.xtraItems.up,
    validate: function () {
      return validate(this.requestItems)
    }
  },
  oppAttack: { // swipe down
    requestItems: swipe.requestItems.oppAttack,
    resultItems: swipe.resultItems.oppAttack,
    xtraResultItems: swipe.xtraItems.down,
    validate: function () {
      return validate(this.requestItems)
    }
  },
}


